module.exports = __webpack_public_path__ + "img/head.7944c61a.png";